import React from 'react';
import {useRef, useState, useEffect} from '@wordpress/element';
import {Box} from '@lapilli-ui/components';
import {SearchField} from '../../../../base/components';
import {useSearchContext} from '../../context';
import {useMediaQuery} from "../../../../base/utils/functions";

const Block = (props) => {
  const {placeholder = ''} = props;
  const {query, setQuery, inputFocused, setInputFocused, size} = useSearchContext();
  const ref = useRef(null);
  const isSmallDevice = useMediaQuery('(max-width: 600px)');
  const [mobileOpened,setMobileOpened] = useState(false);
  const [q, setQ] = useState(query);

  useEffect(() => {
    setQ(query);
  }, [query]);
  useEffect(() => {
    const delayUpdate = setTimeout(() => {
      setQuery(q);
    }, 500);

    return () => clearTimeout(delayUpdate);
  }, [q]);

  useEffect(()=>{
    if( inputFocused) {
      if (isSmallDevice) {
        !mobileOpened && createSearchMobile();
      }else{
        destroySearchMobile();
      }
    }
  },
      [isSmallDevice, inputFocused]
  );

  const createSearchMobile = () =>{
    const wpAdmin = document.querySelector('#wpadminbar');
    const yithDemo = document.querySelector('#ywtenv-banner');
    let searchMobile = document.querySelector('.ywcas-search-mobile');
    if (!searchMobile) {
      searchMobile = document.createElement('div');
      searchMobile.classList.add('ywcas-search-mobile');
      (wpAdmin || yithDemo) && searchMobile.classList.add('with-wp-admin-toolbar');

      const block = inputFocused.closest('.wp-block-yith-search-block');
      const index = Array.prototype.indexOf.call(block.parentNode.childNodes, block);
      block.parentNode.classList.add('ywcas-block-mounted');
      block.parentNode.dataset.ywcasTarget = index;
      searchMobile.append(block);
      document.body.append(searchMobile);
      document.body.classList.add('ywcas-disable-overflow');
      document.documentElement.style.overflow = 'hidden';
      setMobileOpened(true);
    }
  }

  const destroySearchMobile = () =>{
    const wrapper = document.querySelector('.ywcas-search-mobile')
    if( wrapper ){
      const block = wrapper.querySelector('.wp-block-yith-search-block');
      const targetElement =  document.querySelector('.ywcas-block-mounted');
      const oldPosition = targetElement.dataset.ywcasTarget;
      if( oldPosition < targetElement.childNodes.length -1){
        targetElement.insertBefore(block, targetElement.childNodes[oldPosition]);
      }else{
        targetElement.append(block);
      }

      wrapper.remove();
      targetElement.classList.remove('ywcas-block-mounted');
      document.body.classList.remove('ywcas-disable-overflow');
      document.documentElement.style.overflow = '';
    }
    setMobileOpened(false);
  }
  const resetQuery = () =>{
    destroySearchMobile();
    setQ('');
    setInputFocused(null);
  }
  const handleOnChange = (event, value) => {
    if (!event) {
      setQ(value);
    } else {
      event.stopPropagation();
      if (!inputFocused) {
        setInputFocused(ref?.current);
      }
      if (q !== event.target.value) {
        setQ(event.target.value);
      }
    }
  };

  const setFocusOn = () => {
    setInputFocused(ref?.current);
  };
  return (
      <Box ref={ref}>
        <SearchField placeholder={placeholder} setSearchQuery={handleOnChange}
                     queryString={q} onFocus={setFocusOn} onCloseMobile={resetQuery} size={size} isSmallDevice={isSmallDevice} {...props}
        />
      </Box>
  );
};

export default Block;
